import(/* webpackMode: "eager" */ "/srv/gentletales/next-app/app/error.tsx");
